import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { registerServiceWorker } from './utils/serviceWorker';

declare global {
  interface Window {
    snapSaveState?: () => Promise<void> | void;
  }
}

const rootElement = document.getElementById('root') as HTMLElement;

const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// react-snap waits on this before saving HTML, so entrance animations and
// lazy route chunks are in the snapshot instead of the loading shell.
if (typeof navigator !== 'undefined' && navigator.userAgent.includes('ReactSnap')) {
  window.snapSaveState = () =>
    new Promise((resolve) => {
      window.setTimeout(resolve, 1200);
    });
}

if (rootElement.hasChildNodes()) {
  hydrateRoot(rootElement, app, {
    onRecoverableError(error) {
      console.warn('Hydration recovered', error);
    },
  });
} else {
  const root = createRoot(rootElement);
  root.render(app);
}

if (typeof requestIdleCallback !== 'undefined') {
  requestIdleCallback(
    () => {
      reportWebVitals();
      registerServiceWorker();
    },
    { timeout: 2000 }
  );
} else {
  window.addEventListener('load', () => {
    setTimeout(() => {
      reportWebVitals();
      registerServiceWorker();
    }, 0);
  });
}
